import { SIZE } from 'baseui/button'
import { Notification, KIND as NOTIFICATION_KIND } from 'baseui/notification'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'baseui/snackbar'

import { selectOrganizationsSelectedProvider } from '../organizationsManagementSelectors'
import { nettingUpdaterActions } from './nettingUpdaterSagas'
import { selectNettingTarget, selectNettingUpdaterStoreData } from './nettingUpdaterSelectors'
import { ActionsRow, NotificationsWrapper } from './styled-components'

const NettingApiForm = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation('organizationManagement')
  const { enqueue } = useSnackbar()

  const target = useSelector(selectNettingTarget)
  const organizationProvider = useSelector(selectOrganizationsSelectedProvider)
  const selectedProvider = target ?? organizationProvider
  const { isSubmitting, resultError, resultMessage } = useSelector(selectNettingUpdaterStoreData)

  const hasSuccessMessage = resultMessage && !resultError
  const hasErrorMessage = Boolean(resultError)

  const onSubmit = () => {
    dispatch({
      type: nettingUpdaterActions.SUBMIT_API,
      enqueue,
      t,
      technicalName: selectedProvider?.integration_technical_name,
    })
  }

  return (
    <div>
      <ActionsRow>
        <SDButton onClick={onSubmit} isLoading={isSubmitting} disabled={isSubmitting} size={SIZE.compact}>
          {t('netting.api.button_submit')}
        </SDButton>
      </ActionsRow>

      {hasSuccessMessage && (
        <NotificationsWrapper>
          <Notification
            kind={NOTIFICATION_KIND.positive}
            overrides={{ Body: { style: { width: 'auto', marginLeft: 0 } } }}
          >
            {String(resultMessage)}
          </Notification>
        </NotificationsWrapper>
      )}

      {hasErrorMessage && (
        <NotificationsWrapper>
          <Notification
            kind={NOTIFICATION_KIND.negative}
            overrides={{ Body: { style: { width: 'auto', marginLeft: 0 } } }}
          >
            {String(resultError)}
          </Notification>
        </NotificationsWrapper>
      )}
    </div>
  )
}

export default NettingApiForm
